import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CollectionComponent } from './pages/collection/collection.component';
import { CollectionsComponent } from './pages/collections/collections.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { PageComponent } from './pages/page/page.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'gallery',
    pathMatch: 'full',
  },
  { path: 'gallery', component: GalleryComponent },
  { path: 'collections', component: CollectionsComponent },
  { path: 'page/:uid', component: PageComponent },
  { path: 'collection/:uid', component: CollectionComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
